/* eslint-disable */
import { auth0Client } from 'customHooks';
import { PRODUCT_BASE_PATH } from 'appConstants';

export const getAuth0Token = async () => {
  try {
    const token = await auth0Client.getTokenSilently();
    const claims = await auth0Client.getIdTokenClaims();
    return {
      accessToken: token,
      idToken: claims.__raw,
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

export const logoutAuth0 = () => {
  try {
    auth0Client.logout({ returnTo: `${PRODUCT_BASE_PATH}/#/login` });
  } catch (e) {
    console.log('auth0Client.logout error ::', e);
  }
};
